import React, { useEffect, useCallback } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Login from "../views/Login";
import Home from "../views/Home";
import Dashboard from "../views/Dashboard";
import Editor from "../views/Editor";
import Resources from "../views/Resources";
import AddResource from "../views/AddResource";
import ReportView from "../views/ReportView";
// import Authenticate from '../views/Login/Authenticate';
// import ProtectedRoute from '../views/ProtectedRoute';
import { getCurrentUserAsync } from "../redux/userSlice";
import Groups from "../views/Groups";
import AuthorizedRoute from "./AuthorizedRoute";
import ScheduleReports from "../views/ScheduleReports";
import ScheduleLogsTable from "../views/ScheduleReports/ScheduleLogsTable";
import CreateSchedule from "../views/ScheduleReports/CreateSchedule";
import ShareReportForm from "../views/ScheduleReports/ShareReportForm";
import ReportHtmlView from "../views/ReportHtmlView";
import ForgetPassword from "../views/ForgetPassword/ForgetPassword";
import OTPVerify from "../views/OTPVerification/OTPVerify";
import CreateNewPwd from "../views/NewPassword/CreateNewPwd";
import DashboardView from "../views/DashboardView";
import Setting from "../views/Settings/Setting";
import Support from "../views/Supports/Support";
import DashboardsList from "../views/DashboardList/DashboardList";
import CreateDashboard from "../views/CreateDashboard";
import ErrorBoundary from "../components/ErrorBoundary";

function AppRoutes() {
  const dispatch = useDispatch();
  const userdata = useSelector((state) => state.user);

  const fetchCurrentUser = useCallback(() => {
    dispatch(getCurrentUserAsync());
  }, [dispatch]);

  useEffect(() => {
    fetchCurrentUser();
  }, [fetchCurrentUser]);

  return (
    <Router>
      <Switch>
        <Route path="/login">{userdata.user && !userdata.user.isSigned ? <Login /> : <Redirect to="/" />}</Route>
        <Route exact path="/forget-password">
          <ForgetPassword />
        </Route>
        <Route exact path="/create-new-password">
          <CreateNewPwd />
        </Route>
        <Route exact path="/otp-verify">
          <OTPVerify />
        </Route>
        {/* The editor is wrapped so an unexpected payload shows a message instead of
            unmounting the whole app to a blank page. */}
        <Route exact path="/editor/:id/">
          <DashboardView noMargin={true}>
            <ErrorBoundary message="We could not open the editor for this report. This is usually caused by unexpected data coming back from the server.">
              <Editor />
            </ErrorBoundary>
          </DashboardView>
        </Route>
        <Route exact path="/editor/:id/:selectedId">
          <DashboardView noMargin={true}>
            <ErrorBoundary message="We could not open the editor for this report. This is usually caused by unexpected data coming back from the server.">
              <Editor />
            </ErrorBoundary>
          </DashboardView>
        </Route>

        <Route path="/resources">
          <Resources />
        </Route>

        {/* <ProtectedRoute path="/resources" component={Resources} /> */}
        <Route path="/add-resource">
          <AddResource />
          {/* {(userdata.user && userdata.user.isSigned) ?
            <Resources />
            : <Redirect to="/login" />
          } */}
        </Route>

        <AuthorizedRoute path={`/groups`} isAuthorized={true || (userdata.user && userdata.user.isSigned)}>
          <Groups />
        </AuthorizedRoute>

        <AuthorizedRoute path={`/create-dashboard`} isAuthorized={true || (userdata.user && userdata.user.isSigned)}>
          <ErrorBoundary message="We could not open the create form. Please reload and try again.">
            <CreateDashboard />
          </ErrorBoundary>
        </AuthorizedRoute>

        <AuthorizedRoute path={`/dashboard-list`} isAuthorized={true || (userdata.user && userdata.user.isSigned)}>
          <ErrorBoundary message="We could not load your dashboards. Please reload and try again.">
            <DashboardsList />
          </ErrorBoundary>
        </AuthorizedRoute>

        <AuthorizedRoute path={`/scheduling`} isAuthorized={true || (userdata.user && userdata.user.isSigned)}>
          <ScheduleReports />
        </AuthorizedRoute>

        <AuthorizedRoute path={`/create-schedule`} isAuthorized={true || (userdata.user && userdata.user.isSigned)}>
          <CreateSchedule />
        </AuthorizedRoute>

        <AuthorizedRoute path={`/settings-page`} isAuthorized={true || (userdata.user && userdata.user.isSigned)}>
          <Setting />
        </AuthorizedRoute>

        <AuthorizedRoute path={`/support-page`} isAuthorized={true || (userdata.user && userdata.user.isSigned)}>
          <Support />
        </AuthorizedRoute>

        <AuthorizedRoute
          path={`/share-schedule-report`}
          isAuthorized={true || (userdata.user && userdata.user.isSigned)}
        >
          <ShareReportForm />
        </AuthorizedRoute>

        <AuthorizedRoute path={`/schedule-logs`} isAuthorized={true || (userdata.user && userdata.user.isSigned)}>
          <ScheduleLogsTable />
        </AuthorizedRoute>

        <Route path="/report-view">
          <ReportView />
        </Route>

        <Route path="/board/:boardId">
          <ErrorBoundary message="We could not display this dashboard. This is usually caused by unexpected data coming back from the server.">
            <Dashboard />
          </ErrorBoundary>
        </Route>
        <Route path="/report/:boardId">
          <ErrorBoundary message="We could not display this report. This is usually caused by unexpected data coming back from the server.">
            <Dashboard />
          </ErrorBoundary>
        </Route>

        {/* Drill-down targets open here, with parameters from the query string, so it is
            the most exposed page in the app - it must degrade rather than blank out. */}
        <AuthorizedRoute path="/report-html-view/:boardId" isAuthorized={true}>
          <ErrorBoundary message="We could not display this report. This is usually caused by unexpected data coming back from the server.">
            <ReportHtmlView />
          </ErrorBoundary>
        </AuthorizedRoute>

        <Route path="/">
          {userdata.user && userdata.user.isSigned ? (
            <DashboardView>
              <Home />
            </DashboardView>
          ) : (
            <Redirect to="/login" />
          )}
        </Route>
      </Switch>
    </Router>
  );
}

export default AppRoutes;
